module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "hanging",
    attrs: {
      "id": "fm"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }), _vm._v("Hear this, ye old men,")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("and give ear, all ye inhabitants of the land.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Hath this been in your days,")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("or even in the days of your fathers?"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Tell ye your children of it,")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("and let your children tell their children,")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("and their children another generation.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("BOOK OF JOEL")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER ONE, VERSES 2 AND 3")])])]), _vm._v(" "), _c('figure', [_c('img', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "alt": "",
      "src": "OEBPS/images/1-1.jpg"
    }
  }), _vm._v(" "), _c('figcaption', [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795346743_epub_c07_r1#link-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A group of Jews from Berehovo, Ruthenia")]), _vm._v(", shortly after reaching Auschwitz, and before being sent to the gas chambers, photographed by an SS Sergeant.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37e0b5d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780795346743_epub_fm_r1.vue
// module id = 75
// module chunks = 0